import { GridButtons } from "@/controls/buttons/GridButtons";
import { rollPositionCodes } from "@/shared/selectors/RollPositionSelector";
import { rollStatusCodes } from "@/shared/selectors/RollStatusSelector";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { RollPositionTag } from "../../../shared/components/RollPositionTag";
import { RollStatusTag } from "../../../shared/components/RollStatusTag";
import { UniversalRoll } from "@/pages/catalogs/models/UniversalRoll";

type Props = {
	setSelectedRowData: (roll: UniversalRoll) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};
export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		// Hide
		{
			field: "ArborPartName",
			headerName: "Arbor",
			hide: true,
		},
		{
			field: "LocationName",
			headerName: "Location",
			hide: true,
		},
		{
			field: "RollsetLetter",
			headerName: "Letter",
			hide: true,
		},
		{
			field: "RFIDTag",
			headerName: "Tag",
			hide: true,
		},
		{
			field: "Comments",
			headerName: "Comments",
			hide: true,
		},
		// Visible
		{
			field: "PartName",
			headerName: "Name",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "DonutPartName",
			headerName: "Donut",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "StandName",
			headerName: "Stand",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "IsInActiveRollset",
			headerName: "In Rollset",
			minWidth: 20,
			maxWidth: 70,
			flex: 1,
			valueGetter: (params) =>
				(params.data as UniversalRoll).IsInActiveRollset ? "Yes" : "No",
		},
		{
			field: "RollStatusCode",
			headerName: "Status",
			minWidth: 20,
			maxWidth: 70,
			flex: 1,
			valueGetter: (params) =>
				rollStatusCodes.find(
					(code) => code.Code === (params.data as UniversalRoll).RollStatusCode,
				)?.Name,
			cellRenderer: RollStatusTag,
			cellRendererParams: (params: ICellRendererParams) => ({
				status: rollStatusCodes.find(
					(code) => code.Code === (params.data as UniversalRoll).RollStatusCode,
				),
			}),
		},
		{
			field: "RollPosition",
			headerName: "Position",
			minWidth: 20,
			maxWidth: 70,
			flex: 1,
			valueGetter: (params) =>
				rollPositionCodes.find(
					(code) => code.Code === (params.data as UniversalRoll).RollPosition,
				)?.Name,
			cellRenderer: RollPositionTag,
			cellRendererParams: (params: ICellRendererParams) => ({
				position: rollPositionCodes.find(
					(code) => code.Code === (params.data as UniversalRoll).RollPosition,
				),
			}),
		},
		{
			field: "-",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				id: params.data as UniversalRoll,
				setShowModal: setShowModal,
				edit: false,
				showContextMenu: () =>
					showContextMenu(event, params.data, "universalRollContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			flex: 1,
			maxWidth: 180,
			autoHeaderHeight: true,
		},
	];
	return { columnDefs };
};
